'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (client, data, browserHistory) {
  var middleware = (0, _clientMiddleware2.default)(client);
  var finalCreateStore = void 0;
  var enhancers = [];

  if (__DEVELOPMENT__ || browserHistory) {
    enhancers.push((0, _redux.applyMiddleware)((0, _reactRouterRedux.routerMiddleware)(browserHistory), _reduxThunk2.default, middleware));
  } else {
    enhancers.push((0, _redux.applyMiddleware)(_reduxThunk2.default, middleware));
  }

  if (__CLIENT__) {
    enhancers.push((0, _reduxLocalstorage2.default)(undefined, { slicer: slicer, merge: merge }));
    if (__DEVELOPMENT__ && __DEVTOOLS__) {
      enhancers.push(window.devToolsExtension ? window.devToolsExtension() : function (f) {
        return f;
      });
    }

    // if (__DEVTOOLS__) {
    //   enhancers.push(window.devToolsExtension ? window.devToolsExtension() : f => f,);
    // }
  }

  finalCreateStore = _redux.compose.apply(this, enhancers)(_redux.createStore);
  return finalCreateStore(reducer, data);
};

var _redux = require('redux');

var _reactRouterRedux = require('react-router-redux');

var _reduxLocalstorage = require('redux-localstorage');

var _reduxLocalstorage2 = _interopRequireDefault(_reduxLocalstorage);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _ramda = require('ramda');

var _ramda2 = _interopRequireDefault(_ramda);

var _clientMiddleware = require('./clientMiddleware');

var _clientMiddleware2 = _interopRequireDefault(_clientMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global __DEVELOPMENT__, __CLIENT__, __DEVTOOLS__ */
var reducer = require('./modules/reducer');

function mergeArray(a, b) {
  if (Array.isArray(a) && Array.isArray(b)) {
    if (b.length && b[0].type) {
      var typesPersisted = _ramda2.default.pluck('type')(b);
      var isExistingType = function isExistingType(t) {
        return typesPersisted.indexOf(t.type) <= -1;
      };
      var newTypes = _ramda2.default.filter(isExistingType, a);
      return b.concat(newTypes);
    }
  }

  return b;
}

var merge = function merge(initialState, persistedState) {
  return persistedState ? _ramda2.default.mergeDeepWith(mergeArray, initialState, persistedState) : initialState;
};

var slicer = function slicer(paths) {
  return function (state) {
    var subset = {};

    _ramda2.default.mapObjIndexed(function (value, key) {
      if (value.persistToLocalStorage) {
        subset[key] = value;
      }
    }, state);

    return subset;
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/create.js
// module id = 1616
// module chunks = 0